var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56934 9.12646C5.53626 9.12646 7.42263 9.81016 8.81345 11.0272C10.2042 12.2441 10.9856 13.8947 10.9856 15.6157",
    stroke: "#3749A6",
    strokeWidth: 1.39056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0631 8.35519C11.703 8.35519 12.2219 7.83638 12.2219 7.1964C12.2219 6.55641 11.703 6.0376 11.0631 6.0376C10.4231 6.0376 9.9043 6.55641 9.9043 7.1964C9.9043 7.83638 10.4231 8.35519 11.0631 8.35519Z",
    fill: "#3749A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9856 15.6157H5.88693C4.60696 15.6157 3.56934 14.5781 3.56934 13.2982V4.9548C3.56934 3.67483 4.60696 2.63721 5.88693 2.63721H14.2303C15.5102 2.63721 16.5479 3.67483 16.5479 4.9548V9.12648",
    stroke: "#3749A6",
    strokeWidth: 1.39056,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 14.2253H18.4018",
    stroke: "#3749A6",
    strokeWidth: 1.39056,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.085 11.9077V16.5429",
    stroke: "#3749A6",
    strokeWidth: 1.39056,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload_img.9d3a74a151467428af999a7ec38a3c3f.svg";
export { ForwardRef as ReactComponent };